import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    categoryList: [],
    lastQuery: null,
};

const mutations = {
    [type.SET_CATEGORY_LIST](state, categories) {
        state.categoryList = categories;
    },

    [type.ADD_CATEGORY](state, category) {
        state.categoryList.push(category);
    },
};

const getters = {
    categories(state) {
        return state.categoryList;
    },
};

const actions = {
    getCategoriesListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.categoryList.length || state.lastQuery != params.query) {
            return dispatch('getCategories', params);
        }

        return Promise.resolve(state.categoryList);
    },

    getCategories({ commit }) {
        let route = Laroute.route('franchise.vue.categories');

        axios.get(route).then(res => {
            commit(type.SET_CATEGORY_LIST, res.data);
        });
    },

    getCategory({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.inventory.category.show', {
            id: id,
        });
        startLoading(dispatch, 'fetch-category');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-category');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-category');
                throw err;
            });
    },

    updateCategory({ commit, dispatch }, category) {
        let route = Laroute.route('franchise.inventory.category.update', {
            id: category.id,
        });
        startLoading(dispatch, 'save-category');

        return axios
            .patch(route, category)
            .then(res => {
                endLoading(dispatch, 'save-category');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-category');
                throw err;
            });
    },

    createCategory({ commit, dispatch }, category) {
        let route = Laroute.route('franchise.inventory.category.store');
        startLoading(dispatch, 'save-category');

        return axios
            .post(route, category)
            .then(res => {
                commit(type.ADD_CATEGORY, res.data);
                endLoading(dispatch, 'save-category');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-category');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
